export default __webpack_public_path__ + "static/media/WHITEPAPER. LA QUINTA EVOLUCIOìN DE LA BANCA DIGITAL EN MEìXICO NOVA..c7d726a1.pdf";